var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ine-form__error-wrapper"},[_c('p',{class:['ine-form__error', _vm.onlyOneField && 'ine-form__error--one-field']},[_c('AlertCircleIcon',{staticClass:"ine-form__error-icon"}),_vm._v(_vm._s(_vm.errors)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }